import axios from 'axios';

const baseURL = `${process.env.VUE_APP_NEW_API_URL}`

export default {
    getCurrentRound() {
        try {
            return axios.get(`${baseURL}/lotto-demo`)
        } catch (e) {
            throw e
        }
    },
    openNewRound(data) {
        try {
            return axios.post(`${baseURL}/lotto-demo`, data)
        } catch (e) {
            throw e
        }
    },
    updateRound(data) {
        try {
            return axios.put(`${baseURL}/lotto-demo`, data)
        } catch (e) {
            throw e
        }
    },
    toggleBetStatus() {
        try {
            return axios.post(`${baseURL}/lotto-demo/toggle-status`)
        } catch (e) {
            throw e
        }
    },
    getBetList(id) {
        try {
            return axios.get(`${baseURL}/lotto-demo/${id}/bet`)
        } catch (e) {
            throw e
        }
    },
    submitResult(betNumber, isPreview) {
        try {
            return axios.post(`${baseURL}/lotto-demo/result/preview`, { betNumber, isPreview })
        } catch (e) {
            throw e
        }
    }
}